import { DataSource, Label, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalSettlementHistory extends Layout {
    labelTitle: Label;
    panelPageTitle: Panel;
    panelSettlementFields: Panel;
    panelSettlementTableContainer: Panel;
    searchpanelSettlement: SearchPanel;
    sourceSettlement: DataSource;
    tableSettlement: Table;
    textboxCarrierProNbr: Textbox;
    textboxCheckNumber: Textbox;
    textboxDeliveryDate: Textbox;
    textboxOrderId: Textbox;
    textboxPayDate: Textbox;
}
